import lodash from 'lodash';

export const getState = (state, param = null, defaultValue = null) => lodash.get(state, 'inventory.inventoryScan' + (param ? '.' + param : ''), defaultValue);
